import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };
  return (
    <div>
      <main className="vara_license_consultant rwa">
        <header>
          {/* <Header /> */}
          <NewHead />
        </header>
        <Helmet>
          <title>Real World Asset Tokenization - Beleaf Technologies</title>

          <meta name="title" content="Real World Asset Tokenization" />
          <meta
            name="description"
            content="From fractional ownership and increased liquidity to streamlined transactions and improved transparency, we offer a comprehensive Real world asset tokenization solution for tokenizing your physical assets."
          />

          <meta
            property="og:title"
            content="Real World Asset Tokenization - Beleaf Technologies"
          />
          <meta property="og:site_name" content="Beleaf Technologies" />

          <link
            rel="canonical"
            href="https://www.beleaftechnologies.com/real-world-asset-token-development"
          />
        </Helmet>
        <main className="memecoin_main text-white">
          <section className="memecoin_bannersec d-flex align-items-center RWA_Banner">
            <div className="container">
              <div className="section_banner_VAT">
                <div className="row">
                  <div className="col-lg-6 ">
                    <div className="memecoin_bannersec_content d-flex flex-column">
                      <h1 className="mb-0">Real world Asset Tokenization</h1>
                    </div>
                  </div>
                  <div className="col-lg-6 ">
                    <div className="memecoin_bannersec_content d-flex flex-column">
                      <p className="mb-0 memecoin_p">
                        Create your digital tokens representing real-world
                        assets such as real estate, commodities, or Art. Trade
                        them on a blockchain platform, allowing investors to buy
                        and sell them easily.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Contact Us"
                        className="memecoin_button"
                      >
                        Let's Discuss
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="main_image_">
                    <img
                      src={require("../../image/RWA/banner.webp")}
                      className=""
                      alt="Real World Asset Tokenization Development"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="memecoin_whychoosesec banner_2_section1 inner_spaceinga">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 d-flex justify-content-center">
                  <div className="memecoin_whychoosesec_img d-flex">
                    <img
                      src={require("../../image/RWA/whatRWA.webp")}
                      className="img_flow"
                      alt="Real World Asset Tokenization Development"
                    />
                  </div>
                </div>
                <div className="col-lg-6 d-flex align-items-center flex-column justify-content-center">
                  <div className="memecoin_whychoosesec_content d-flex flex-column w-100 mb-5 ">
                    <h2 className="mb-0 memecoin_h2">
                      What is a Real World Asset Tokenization?
                    </h2>
                    <p className="mb-0 memecoin_p">
                      A Real World Asset Tokenization is a development digital
                      representation of a real-world asset. It is created using
                      blockchain technology, which ensures that the token is
                      secure and tamper-proof. The token is backed by the value
                      of the underlying asset, which means that its value is
                      directly linked to the value of the asset it represents.
                      Real world asset tokenization is the process of creating a
                      token representing the particular real world asset.
                    </p>
                    <a href="https://wa.me/7904323274" className="">
                      <button className="memecoin_button">
                        Talk To Our Experts
                      </button>
                    </a>
                  </div>
                </div>
                <div className="col-lg-12"></div>
              </div>
            </div>
          </section>
          <section className="memecoin_whychoosesec banner_2_section1 inner_spaceinga">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 d-flex align-items-center flex-column justify-content-center">
                  <div className="memecoin_whychoosesec_content d-flex flex-column w-100 mb-5 ">
                    <h2 className="mb-0 memecoin_h2">
                      How are Real World Asset Tokenization Created?
                    </h2>
                    <p className="mb-0 memecoin_p">
                      Real World Asset Tokenization are created using a process
                      called tokenization. This involves converting the rights
                      to an asset into a digital token, which can then be traded
                      on a blockchain platform. The process of tokenization is
                      usually carried out by a blockchain development company,
                      which ensures that the tokens are created in a secure and
                      transparent manner.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="memecoin_button"
                    >
                      Learn more
                    </button>
                  </div>
                </div>
                <div className="col-lg-6 d-flex justify-content-center">
                  <div className="memecoin_whychoosesec_img d-flex">
                    <img
                      src={require("../../image/RWA/howRWA.webp")}
                      className="img_flow"
                      alt="Real World Asset Tokenization Development"
                    />
                  </div>
                </div>
                <div className="col-lg-12"></div>
              </div>
            </div>
          </section>
          <section className="memecoin_whychoosesec inner_spaceinga">
            <div className="container">
              <div className="">
                <div className="row">
                  <div className="col-lg-12 d-flex align-items-start justify-content-center">
                    <div className="memecoin_whychoosesec_content d-flex flex-column ">
                      <h2 className="mb-5 memecoin_h2 text-center">
                        The Advantages of Turning <br />
                        Real-World Assets into Tokens
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-12 d-flex justify-content-center mt-2 BG_no_RWA_Card">
                    <div className="memecoin_benefitssec_cardarea ">
                      <div className="row justify-content-center">
                        <div className="col-lg-4 col-sm-6 d-flex">
                          <div className="memecoin_benefitssec_card d-flex flex-column ">
                            <div className="icon_card">
                              <img
                                src={require("../../image/RWA/liquidity.webp")}
                                className=""
                                alt="Real World Asset Tokenization Development"
                              />
                            </div>
                            <h3 className="mb-0 memecoin_h3">Liquidity</h3>
                            <p className="mb-0 memecoin_card_p">
                              Transform assets that are typically hard to sell
                              into tokens that can be traded more easily. This
                              can attract new investors and make capital more
                              accessible.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 d-flex">
                          <div className="memecoin_benefitssec_card d-flex flex-column ">
                            <div className="icon_card">
                              <img
                                src={require("../../image/RWA/opportunity.webp")}
                                className=""
                                alt="Real World Asset Tokenization Development"
                              />
                            </div>
                            <h3 className="mb-0 memecoin_h3">
                              Access to More Opportunities
                            </h3>
                            <p className="mb-0 memecoin_card_p">
                              Invest in assets that were previously out of
                              reach, thanks to the ability to buy smaller parts
                              of them. This allows people to invest in things
                              like classic cars or fine art without needing a
                              lot of money.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 d-flex">
                          <div className="memecoin_benefitssec_card d-flex flex-column ">
                            <div className="icon_card">
                              <img
                                src={require("../../image/RWA/ownership.webp")}
                                className=""
                                alt="Real World Asset Tokenization Development"
                              />
                            </div>
                            <h3 className="mb-0 memecoin_h3">
                              Shared Ownership
                            </h3>
                            <p className="mb-0 memecoin_card_p">
                              Split assets into smaller parts, making it more
                              affordable for people to invest in them. This
                              allows more people to own a piece of something
                              valuable, like a collection of luxury cars or a
                              solar energy plant.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 d-flex">
                          <div className="memecoin_benefitssec_card d-flex flex-column ">
                            <div className="icon_card">
                              <img
                                src={require("../../image/RWA/payment.webp")}
                                className=""
                                alt="Real World Asset Tokenization Development"
                              />
                            </div>
                            <h3 className="mb-0 memecoin_h3">
                              Potential for More Profit
                            </h3>
                            <p className="mb-0 memecoin_card_p">
                              Tokens can be used to invest in things that have
                              the potential to make a lot of money, like real
                              estate or projects that are being built. This
                              means that people can make more money from their
                              investments.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 d-flex">
                          <div className="memecoin_benefitssec_card d-flex flex-column ">
                            <div className="icon_card">
                              <img
                                src={require("../../image/RWA/hassle-free.webp")}
                                className=""
                                alt="Real World Asset Tokenization Development"
                              />
                            </div>
                            <h3 className="mb-0 memecoin_h3">Hassle Free</h3>
                            <p className="mb-0 memecoin_card_p">
                              Use smart contracts to automate tasks and reduce
                              the amount of time and money spent on
                              administrative work. For example, tokens could be
                              used to make rent payments for real estate or to
                              distribute royalties for music rights.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 d-flex">
                          <div className="memecoin_benefitssec_card d-flex flex-column ">
                            <div className="icon_card">
                              <img
                                src={require("../../image/RWA/business-ethics.webp")}
                                className=""
                                alt="Real World Asset Tokenization Development"
                              />
                            </div>
                            <h3 className="mb-0 memecoin_h3">Transparency</h3>
                            <p className="mb-0 memecoin_card_p">
                              The use of blockchain technology ensures that
                              ownership records are clear and cannot be changed.
                              This helps to build trust and reduces the risk of
                              fraud. People can see who owns what and how assets
                              are being used.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="wazirx_whychoosesec">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div className="wazirx_whychoosesec_img d-flex justify-content-center">
                    <h2> Use Cases Of Real World Asset Tokenization</h2>
                    <div>
                      {/* <a
                        href="https://join.skype.com/invite/wg5IW8g4Uaca"
                        target="blank"
                      > */}
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="talk_button mt-4"
                      >
                        Contact Us
                      </button>
                      {/* </a> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="wazirx_whychoosesec_cardarea mt-5">
                    <div className="row">
                      <div className="col-lg-12 mb-5">
                        <div className="wazirx_whychoosesec_card  align-items-center d-flex inner_width">
                          <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center ">
                            <img
                              src={require("../../image/RWA/real_estate.webp")}
                              alt="Real World Asset Tokenization Development"
                            />
                            <h3 className="wazirx_h3 mb-2 mr-4">
                              {" "}
                              Real Estate
                            </h3>
                            <p className="wazirx_card_p mb-0">
                              Real world asset tokenization makes it possible
                              for more people to own a part of valuable
                              properties, like a fancy apartment in Dubai or an
                              old building in Europe, by splitting them into
                              smaller pieces. It makes it easier to trade
                              properties that are usually hard to sell. For
                              example, you can sell your share of a property
                              quickly on a global market. blockchain technology
                              ensures that ownership records are clear and
                              cannot be changed, which helps to build trust.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 mb-5">
                        <div className="wazirx_whychoosesec_card  align-items-center d-flex inner_width">
                          <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                            <img
                              src={require("../../image/RWA/art.webp")}
                              alt="Real World Asset Tokenization Development"
                            />
                            <h3 className="wazirx_h3 mb-2">
                              {" "}
                              Art and Collectibles
                            </h3>
                            <p className="wazirx_card_p mb-0">
                              Tokenization makes it possible for more people to
                              own a part of valuable art or collectibles, like a
                              famous painting or a rare car. It makes it easier
                              to trade art and collectibles. For example, you
                              can sell your share of a painting on a special
                              market. blockchain technology ensures that the
                              history of ownership is clear and cannot be
                              changed, which helps to prevent fraud.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 mb-5">
                        <div className="wazirx_whychoosesec_card  align-items-center d-flex inner_width">
                          <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                            <img
                              src={require("../../image/RWA/supply-chain.webp")}
                              alt="Real World Asset Tokenization Development"
                            />
                            <h3 className="wazirx_h3 mb-2">
                              {" "}
                              Supply Chain Management
                            </h3>
                            <p className="wazirx_card_p mb-0">
                              It helps to track products easier as they move
                              through the supply chain, which helps to ensure
                              that they are delivered on time and in good
                              condition. Blockchain technology helps to prevent
                              counterfeiting and tampering, which helps to keep
                              products safe. Smart contracts can help automate
                              payments when products are delivered, which saves
                              time and money.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 mb-5">
                        <div className="wazirx_whychoosesec_card  align-items-center d-flex inner_width">
                          <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                            <img
                              src={require("../../image/RWA/intellectual-property.webp")}
                              alt="Real World Asset Tokenization Development"
                            />
                            <h3 className="wazirx_h3 mb-2">
                              Intellectual Property (IP)
                            </h3>
                            <p className="wazirx_card_p mb-0">
                              Real World Asset Tokenization makes it easier to
                              license things like patents and trademarks, which
                              helps to protect them. Real World Asset
                              Tokenization makes it possible to make money in
                              new ways, like through crowdfunding campaigns.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 mb-5">
                        <div className="wazirx_whychoosesec_card  align-items-center d-flex inner_width">
                          <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                            <img
                              src={require("../../image/RWA/carbon.webp")}
                              alt="Real World Asset Tokenization Development"
                            />
                            <h3 className="wazirx_h3 mb-2"> Carbon Credits</h3>
                            <p className="wazirx_card_p mb-0">
                              {" "}
                              It prevents fraud when buying carbon credits,
                              which helps to support eco-friendly initiatives.
                              It enables us to buy and sell carbon credits
                              easily, which helps to support eco-friendly
                              initiatives. Real world asset tokenization makes
                              it possible to attract more investors and funding
                              for environmental projects, which helps to support
                              eco-friendly initiatives.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="real_world_asset inner_spaceinga">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="memecoin_whatissec_content devlop_token d-flex flex-column">
                    <h2 className="mb memecoin_h2 text-center">
                      Blockchains for Real world asset <br />
                      tokenization{" "}
                    </h2>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="parant_card_section mt-4">
                    <div className="crypto_items">
                      <img
                        src={require("../../image/RWA/ethereum.webp")}
                        alt="Real World Asset Tokenization Development"
                      />
                      <p>Ethereum</p>
                    </div>
                    <div className="crypto_items">
                      <img
                        src={require("../../image/RWA/Polygon.webp")}
                        alt="Real World Asset Tokenization Development"
                      />
                      <p>Polygon</p>
                    </div>
                    <div className="crypto_items">
                      <img
                        src={require("../../image/RWA/Stellar.webp")}
                        alt="Real World Asset Tokenization Development"
                      />
                      <p>Stellar</p>
                    </div>
                    <div className="crypto_items">
                      <img
                        src={require("../../image/RWA/hyper22.webp")}
                        alt="Real World Asset Tokenization Development"
                      />
                      <p>Hyperledger</p>
                    </div>
                    <div className="crypto_items">
                      <img
                        src={require("../../image/RWA/solana.webp")}
                        alt="Real World Asset Tokenization Development"
                      />
                      <p>Solana</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="memecoin_whatissec inner_spaceinga">
            <div className="container">
              <div className="row justify-content-center mt-5 mb-5">
                <div className="col-lg-10 text-center">
                  <div className="memecoin_whatissec_content d-flex flex-column">
                    <h2 className="mb-0 memecoin_h2">
                      Start your Real World Asset tokenization with us{" "}
                    </h2>
                    <p className="mb-0 memecoin_p">
                      Real World Asset tokenization is an exciting and
                      innovative concept that is changing the way we think about
                      physical assets. By creating digital tokens that represent
                      real-world assets, investors can buy and sell assets more
                      efficiently and cost-effectively. Get a consultation on
                      your Real World Asset tokenization from our expert.
                    </p>
                  </div>
                </div>

                <div className="col-lg-12 text-center mt-4">
                  <a href="https://wa.me/7904323274" className="">
                    <button className="talk_button">Talk To Our Experts</button>
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
      </main>
      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
